import { Vector as VectorLayer } from "ol/layer";
import { Vector as VectorSource } from "ol/source";
import { LayerDefaults, LayerTitle } from "../types/layers";
import { readMapSettings } from "./localMapSettings";

interface Return {
  source: VectorSource;
  layer: VectorLayer;
}

export function createProjectLayer(): Return {
  const source = new VectorSource();
  const title = LayerTitle.Projects;

  const layer = new VectorLayer({
    source,
    zIndex:
      readMapSettings("layers", title)?.zIndex ?? LayerDefaults[title].zIndex,
    visible:
      readMapSettings("layers", title)?.visible ?? LayerDefaults[title].visible,
    declutter: true,
  });
  layer.set("title", title);
  layer.set("hideSettings", LayerDefaults[title].hideSettings);
  return { source, layer };
}

export function createProjectPlanningLayer(): Return {
  const source = new VectorSource();
  const title = LayerTitle.ProjectsPlanning;
  const layer = new VectorLayer({
    source,
    zIndex:
      readMapSettings("layers", title)?.zIndex ?? LayerDefaults[title].zIndex,
    visible:
      readMapSettings("layers", title)?.visible ?? LayerDefaults[title].visible,
  });
  layer.set("title", title);
  layer.set("hideSettings", LayerDefaults[title].hideSettings);
  return { source, layer };
}

export function createProjectPoiItemLayer(): Return {
  const source = new VectorSource();
  const title = LayerTitle.ProjectPoiItems;

  const layer = new VectorLayer({
    source,
    zIndex:
      readMapSettings("layers", title)?.zIndex ?? LayerDefaults[title].zIndex,
    visible:
      readMapSettings("layers", title)?.visible ?? LayerDefaults[title].visible,
  });
  layer.set("title", title);
  layer.set("hideSettings", LayerDefaults[title].hideSettings);
  return { source, layer };
}
